var _g, _path, _circle, _circle2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1979 24.1979C49.8301 29.8301 49.8301 38.9616 44.1979 44.5938C38.5658 50.2259 29.4342 50.2259 23.8021 44.5938C18.1699 38.9616 18.1699 29.8301 23.8021 24.1979C29.4342 18.5658 38.5658 18.5658 44.1979 24.1979Z",
    fill: "url(#paint0_linear)",
    stroke: "url(#paint1_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9236 31L31.7261 38.9491L28 35.3359",
    stroke: "white",
    strokeWidth: 1.5818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5076 59.85C41.595 63.6247 56.0752 55.2646 59.8499 41.1771C60.9821 36.9519 61.0226 32.6913 60.1444 28.6948M41.177 8.83474C27.0896 5.06002 12.6094 13.4201 8.83469 27.5076C7.31259 33.1882 7.7636 38.9326 9.7676 44.0132C10.0125 44.6341 10.2807 45.2452 10.5712 45.845",
    stroke: "url(#paint2_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.2825,
    cy: 23.1657,
    r: 4.6436,
    transform: "rotate(15 59.2825 23.1657)",
    stroke: "url(#paint3_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8907,
    cy: 50.0392,
    r: 4.6436,
    transform: "rotate(-164.222 12.8907 50.0392)",
    stroke: "url(#paint4_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 23.8021,
    y1: 24.1979,
    x2: 44.1979,
    y2: 44.5938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF005E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C096C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 23.8021,
    y1: 24.1979,
    x2: 44.1979,
    y2: 44.5938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF005E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C096C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 41.177,
    y1: 8.83474,
    x2: 27.5076,
    y2: 59.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF005E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C096C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 59.2825,
    y1: 18.5221,
    x2: 59.2825,
    y2: 27.8093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF005E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C096C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 12.8907,
    y1: 45.3956,
    x2: 12.8907,
    y2: 54.6828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF005E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C096C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.6081,
    height: 43.6081,
    fill: "white",
    transform: "translate(65.0933 34.2578) rotate(135)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.5ff08748.svg";
export { ForwardRef as ReactComponent };